import React from 'react';
import { PropTypes } from 'prop-types';
import spinner from '../../style/img/ajax-loader.svg';

const Spinner = ({ hidden, style }) => (
  <div
    style={{ minHeight: '100vh', position: 'fixed', ...style }}
    id="spinner"
    className="spinner"
    hidden={hidden}
  >
    <img src={spinner} height="64" width="64" alt="Loading"></img>
  </div>
);

Spinner.propTypes = {
  hidden: PropTypes.bool,
  style: PropTypes.object,
};

Spinner.defaultProps = {
  hidden: false,
  style: {},
};

export default Spinner;
